/*
 * @@Description:
 * @@Author: MuYang
 * @Date: 2021-09-13 16:58:16
 */
import TableRow from './table-row'

export default {
  inject: {
    table: { default: () => ({}) }
  },
  props: ['columns'],

  methods: {
    renderRows (data) {
      const rows = []
      // 处理传入class style
      const { expandColumn, getRowKey, groupRowKey, groupTitleRender, boxReadWidth, prefix } = this.table
      const { columns } = this
      for (let i = 0; i < data.length; i++) {
        const record = data[i]
        const key = getRowKey(record, i)
        const rowProps = {
          key,
          props: {
            columns,
            rowIndex: i,
            row: record,
            syRowKey: key
          }
        }
        let row = <TableRow {...rowProps} />
        // 追加行分组
        if (groupRowKey && (record[groupRowKey] !== data[i - 1]?.[groupRowKey])) {
          rows.push(<tr>
            <div style={{width: `${boxReadWidth}px`}} class={`${prefix}-group-title`}>
              {groupTitleRender({row: record, i})}
            </div>
            </tr>)
        }
        rows.push(row)
        if (expandColumn && this.isExpandRow(key, i)) {
          rows.push(
            this.renderExpand(expandColumn, record, i, key, columns.length)
          )
        }
      }
      return rows
    },
    isExpandRow (key, i) {
      if (this.table.forceExpand) {
        return true
      }
      const {expandRows, getRowKey} = this.table
      return expandRows.some(row => getRowKey(row, i) === key)
    },
    renderExpand (column, record, rowIndex, key, columnsCount) {
      const expandRender = column.customRenderRow || column.slots.customRender
      const _key = `expanded-row-${key}`
      const preifx = this.table.prefix
      return <tr key={_key} class={`${preifx}-expanded-row ${preifx}-row`} data-row-key={_key}>
        <td colspan={columnsCount} class={`${preifx}-column ${preifx}-expanded-cell`}>
          { expandRender({ row: record, $index: rowIndex }) }
        </td>
      </tr>
    }
  },
  render (h) {
    const { dataSource, prefix } = this.table
    return (
      <tbody class={`${prefix}-tbody`}>
        {this.renderRows(dataSource)}
      </tbody>
    )
  },
  components: {
    TableRow
  }
}
